import { render, staticRenderFns } from "./VityCheck.vue?vue&type=template&id=1780c6c5&scoped=true"
import script from "./VityCheck.vue?vue&type=script&lang=js"
export * from "./VityCheck.vue?vue&type=script&lang=js"
import style0 from "./VityCheck.vue?vue&type=style&index=0&id=1780c6c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780c6c5",
  null
  
)

export default component.exports